import { requestAppConfigAdmin } from './auth';

export const RELEASE_PLANNING_QUERY_KEY = 'mobileReleasePlanning';
const BASE_PATH = '/api/v0/mobile/release-planning';

function query(resource, filters = {}) {
  const params = new URLSearchParams({ resource });
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.set(key, String(value));
    }
  });
  return `${BASE_PATH}?${params}`;
}

async function list(resource, filters) {
  const result = await requestAppConfigAdmin(query(resource, filters));
  return result?.items ?? [];
}

export const listReleaseProducts = () => list('products');
export const listReleasePlans = (filters = {}) => list('plans', filters);
export const listReleasePlanItems = (filters = {}) => list('items', filters);
export const listReleasePlanEvents = (filters = {}) => list('events', filters);
export const searchReleaseBranches = (repository, q = '') => list('branches', { repository, q });

export function createReleasePlanningResource(resource, input, environment) {
  return requestAppConfigAdmin(BASE_PATH, {
    method: 'POST',
    body: JSON.stringify({ resource, ...input }),
    expectedEnvironment: environment,
  });
}

export function updateReleasePlanningResource(resource, id, revision, input, action = 'UPDATE', environment) {
  return requestAppConfigAdmin(`${BASE_PATH}?id=${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: JSON.stringify({ resource, revision, action, ...input }),
    expectedEnvironment: environment,
  });
}

export function syncReleasePlanItemEvidence(item) {
  return updateReleasePlanningResource('item', item.id, item.revision, {}, 'SYNC_EVIDENCE');
}
